import { createFileRoute, useNavigate, useParams } from "@tanstack/react-router"
import { SessionRecord } from "@/components/schedule/SessionRecord"

// Full-screen Session record (Activity HQ) for one agenda item. Drilled into
// from a schedule item; a distinct top segment (`session/`) keeps the schedule
// list + grid routes reachable. Breadcrumb back-link lives in the record's
// left pane.
export const Route = createFileRoute("/$orgSlug/$eventSlug/session/$agendaItemId")({
  component: SessionRecordView,
})

function SessionRecordView() {
  const params = useParams({ from: "/$orgSlug/$eventSlug/session/$agendaItemId" })
  const navigate = useNavigate()
  return (
    <SessionRecord
      agendaItemId={params.agendaItemId}
      closeVariant="back"
      onBack={() =>
        navigate({
          to: "/$orgSlug/$eventSlug/schedule",
          params: { orgSlug: params.orgSlug, eventSlug: params.eventSlug },
        })
      }
    />
  )
}
